// extracted by mini-css-extract-plugin
export default {"formGroup":"textArea_formGroup__t7jo+","wrap":"textArea_wrap__upjPT","textarea":"textArea_textarea__NnRd5","error":"textArea_error__dlha7","icons":"textArea_icons__5mVQZ"};